import React from "react";

class CampaignCounter extends React.Component {
  constructor(props) {
    super(props);
    this._tickRef = React.createRef();
  }

  componentDidMount() {
    this._tickInstance =
      Tick.DOM.create(this._tickRef.current, {
        value: this.props.amount,
      }) || Tick.DOM.find(this._tickRef.current);
  }

  componentDidUpdate() {
    if (!this._tickInstance) return;
    this._tickInstance.value = this.props.amount;
  }

  componentWillUnmount() {
    if (!this._tickInstance) return;
    Tick.DOM.destroy(this._tickRef.current);
  }

  render() {
    return (
      <>
        <div className="tick" ref={this._tickRef}>
          <div data-value-mapping="indexes" data-transform="spring -> split">
            <span data-view="flip" />
            <span className="tick-text-inline">&nbsp;</span>
            <span data-view="flip" />
            <span data-view="flip" />
            <span data-view="flip" />
          </div>
        </div>
      </>
    );
  }
}

export default CampaignCounter;
